import { createAsyncThunk } from '@reduxjs/toolkit'

import { IEventCollectionDataActiveEvents, IEventCollectionMetadata } from 'meta/pages/v4/eventCollection'
import { CollectionController } from 'controller/collection'
import { RootState } from 'store/types'

type Params = {
  collectionId: string
  page: number
}

type Returned = {
  data: IEventCollectionDataActiveEvents
  metadata: IEventCollectionMetadata
  collectionId: string
}

export const getEvents = createAsyncThunk<Returned, Params, { state: RootState }>(
  'collection/getEvents',
  async (params) => {
    const { collectionId, page } = params

    const { data, metadata } = await CollectionController.getEvents({ collectionId, page })

    return { data, metadata, collectionId }
  }
)
